export class SupplierUserRequest {
  mobileNumber: string | undefined;
  isActive: boolean | undefined;
  isSuperUser: boolean | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  nationalCode: string | undefined;
  id?:number|undefined;
}

export class GetSupplierUserListResponse {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    isActive: boolean | undefined;
    isSuperUser: boolean | undefined;
    createDate: Date | undefined;
    createDate_Persian: string | undefined;
    modifyDate: Date | undefined;
    modifyDate_Persian: string | undefined;
    nationalCode:string | undefined ;
    mobileNumber:string|undefined;
}
export class GetSupplierUserInfoRequest {
  id: number | undefined;
}

